import { render } from "./CachePage.vue?vue&type=template&id=6dcb4deb&scoped=true"
import script from "./CachePage.vue?vue&type=script&lang=js"
export * from "./CachePage.vue?vue&type=script&lang=js"

import "./CachePage.vue?vue&type=style&index=0&id=6dcb4deb&scoped=true&lang=css"
import "./CachePage.vue?vue&type=style&index=1&id=6dcb4deb&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dcb4deb"]])

export default __exports__